module.exports = __webpack_public_path__ + "resources/warning-small-6ad6a0ca4811931c88cc3adfad5306fd.svg";